import React, { useState } from 'react';

import StyledCheckbox from 'Shared/components/Checkboxes/StyledCheckbox/StyledCheckbox';
import { WpContainer, WpContainerBody, WpContainerHeader } from 'Wpds/components/container';

const HibobSettings = () => {
  const [saveFeedback, setSaveFeedback] = useState(false);
  const [saveKudos, setSaveKudos] = useState(false);
  const [syncSeats, setSyncSeats] = useState(false);

  return (
    <WpContainer>
      <WpContainerHeader>
        <h5>Hibob Integration Settings</h5>
      </WpContainerHeader>
      <WpContainerBody>
        <div className="d-flex flex-column mb-3">
          <StyledCheckbox
            id="save_feedback"
            name="save_feedback"
            label="Save Feedback to Hibob"
            checked={saveFeedback}
            onChange={() => setSaveFeedback(!saveFeedback)}
          />
          <div className="ml-4 text-muted">Save feedback given in PI Perform as files in Hibob</div>
        </div>
        <div className="d-flex flex-column mb-3">
          <StyledCheckbox
            id="save_kudos"
            name="save_kudos"
            label="Save Kudos to Hibob"
            checked={saveKudos}
            onChange={() => setSaveKudos(!saveKudos)}
          />
          <div className="ml-4 text-muted">Save kudos given in PI Perform as files in Hibob</div>
        </div>
        <div className="d-flex flex-column mb-3">
          <StyledCheckbox
            id="sync_seats"
            name="sync seats"
            label="Sync Seats"
            checked={syncSeats}
            onChange={() => setSyncSeats(!syncSeats)}
          />
          <div className="ml-4 text-muted">Create PI Perform seats when Hibob seats are added</div>
        </div>
      </WpContainerBody>
    </WpContainer>
  );
};

export default HibobSettings;
